export default __webpack_public_path__ + "9be4fd222394ef255ee08c83fdb43b18.png";